/** User-facing fallback copy for decision-guide surfaces (calm, non-blaming). */

export const DECISION_GUIDE_INTAKE_LOADING_TITLE = 'Gathering orientation';
export const DECISION_GUIDE_INTAKE_LOADING_BODY =
    'Hang tight—we are refreshing this list so guidance stays in sync with what the server verified.';

export const DECISION_GUIDE_INTAKE_ERROR_TITLE = 'Orientation preview unavailable';
export const DECISION_GUIDE_INTAKE_ERROR_BODY =
    'We could not show the short summary from your document list. Your file is still safe—try refreshing the list.';

export const DECISION_GUIDE_INTAKE_ROW_INCONSISTENT =
    'Guidance metadata looks incomplete for this row. Refresh the document list, or open the linked task for full details when available.';

export const DECISION_GUIDE_DRAWER_LOADING_TITLE = 'Loading guidance';
export const DECISION_GUIDE_DRAWER_LOADING_BODY =
    'Fetching verified guidance from your document…';

export const DECISION_GUIDE_DRAWER_ERROR_TITLE = 'Guidance could not be loaded';
export const DECISION_GUIDE_DRAWER_ERROR_BODY =
    'Something went wrong while loading this document’s details. Other information below may still be useful.';

export const DECISION_GUIDE_DRAWER_MALFORMED_TITLE = 'Guidance could not be shown';
export const DECISION_GUIDE_DRAWER_MALFORMED_BODY =
    'We received guidance in an unexpected format. Your document is still saved—try closing and reopening this item, or refresh if the problem continues.';

export const DECISION_GUIDE_LIST_FAILED_TITLE = 'Documents could not be loaded';
export const DECISION_GUIDE_LIST_FAILED_BODY =
    'We could not refresh your document list. Check your connection and try again.';
